module.exports = __webpack_public_path__ + "img/footer-icon-2.faee9650.png";